// External-link interstitial for server-rendered rich content (.rich-text-rendered),
// mirroring the inbox's MessageContent modal: same-origin links pass through, external
// links get a confirm step before window.open with noopener.

const isSameOrigin = (href) => {
  try {
    return new URL(href, window.location.href).origin === window.location.origin;
  } catch {
    return false;
  }
};

let modal = null;
let pendingUrl = null;

const hideModal = () => {
  pendingUrl = null;
  if (modal) {
    modal.style.display = 'none';
  }
};

const buildModal = () => {
  // Turbolinks restores cached pages with a listener-less clone of this modal in the body —
  // purge any strays so only the live instance exists.
  document.querySelectorAll('.external-link-warning-modal').forEach((el) => el.remove());
  const wrapper = document.createElement('div');
  wrapper.innerHTML = `
    <div class="modal external-link-warning-modal" tabindex="-1" style="display: block; background: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Open external link</h5>
            <button type="button" class="btn-close" data-role="cancel" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="text-secondary mb-2">You're leaving Qwoted to visit an external link:</p>
            <div class="border rounded p-2 text-break small" data-role="url"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-role="cancel">Cancel</button>
            <button type="button" class="btn btn-primary" data-role="confirm">Open link</button>
          </div>
        </div>
      </div>
    </div>`;
  modal = wrapper.firstElementChild;
  document.body.appendChild(modal);

  modal.addEventListener('click', (event) => {
    if (event.target === modal || event.target.closest('[data-role="cancel"]')) {
      hideModal();
    }
    if (event.target.closest('[data-role="confirm"]')) {
      const url = pendingUrl;
      hideModal();
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  });
};

const showModal = (url) => {
  if (!modal || !document.body.contains(modal)) {
    buildModal();
  }
  pendingUrl = url;
  modal.querySelector('[data-role="url"]').textContent = url;
  modal.style.display = 'block';
};

document.addEventListener('click', (event) => {
  const link = event.target.closest('.rich-text-rendered a[href]');
  if (!link) {
    return;
  }

  const href = link.getAttribute('href');
  if (isSameOrigin(href)) {
    return;
  }

  event.preventDefault();
  showModal(href);
});

// Never let Turbolinks cache the modal into its page snapshots.
document.addEventListener('turbolinks:before-cache', () => {
  if (modal) {
    modal.remove();
    modal = null;
  }
  pendingUrl = null;
});
